module.exports = __webpack_public_path__ + "assets/7861974dd2f8e968f1835d69680a43d0.svg";